/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * Maven (hackathon): hard-coded settings. The graph runs in the sandbox tenant; the data it reads is
 * AI Study Tool only (fixed on the server side).
 */
const MAVEN = Object.freeze({
  // The Maven_Ops graph in Studio (sandbox tenant). Its tool nodes call the DEV ai-admin-services.
  // Must match OWN_GRAPH_ID in ai-admin-services constants.js.
  graphId: '56710ad9-1e56-4d7d-8a15-308f32dbc608',
  // Run the draft version directly; no need to publish.
  version: 1,
  tenantId: '12b793b2-ebae-4058-ad9b-7d8fb5369054',
  // Each question is a fresh graph run, so the last few turns are sent with it for follow-ups ("yes, go ahead").
  historyTurns: 2,
  historyAnswerChars: 1500,
  // Maven is shown to users as a person (a teammate), not as a tool.
  // Shown to users as Berlin Intelligence (code, files and graph keep the Maven name for now).
  name: 'Berlin Intelligence',
  initials: 'BI',
  tagline: 'Your AI insights partner',
  greeting:
    "Hi, I'm Berlin Intelligence. I can look into errors, graph, feedback and much more. What would you like to know?",
  examples: [
    'What are my top 5 books?',
    'Top dislike reasons this week',
    'What are my popular topics?',
    'Check agents quality',
    'How did my evals score this week?'
  ],
  // footer: '*This feature is in Beta and may produce inaccurate results. Please verify all information independently.'
  footer: '*This feature is in Beta and may produce inaccurate results.'
});

export default MAVEN;
